import { Card, CardProps } from 'antd';
import styled from 'styled-components';

interface StyledCardProps extends CardProps {
  $nopadding?: boolean;
  fullsize?: boolean;
  width?: string;
  checked?: boolean;
  $stopshadowbox?: boolean;
  height?: string;
  centercontent?: boolean;
  hideheader?: boolean;
  spreadcontent?: boolean;
  $removeHeader?: boolean;
  $borderless?: boolean;
  bg_color?: string;
  bg?: string;
  $padding?: string;
}

export const StyledCard = styled(Card).withConfig({
  shouldForwardProp: (prop) =>
    ![
      'nopadding',
      'fullsize',
      'width',
      'checked',
      'stopshadowbox',
      'height',
      'centercontent',
      'hideheader',
      'spreadcontent',
      'removeHeader',
      'borderless',
      'bg_color',
      'bg',
      'padding',
      '$padding',
    ].includes(prop),
})<StyledCardProps>`
  width: ${(props) => (props.width ? props.width : 'fit-content')};
  border: ${(props) => (props.$borderless ? 'none' : '1px solid var(--color-border, #dbeae3)')};
  border-radius: var(--border-radius-card, 12px);
  overflow: hidden;
  box-shadow: ${(props) =>
    props.$stopshadowbox ? 'none' : '0px 0px 10px 0px #0000000d'};
  background-color: ${(props) =>
    props.bg_color
      ? props.bg_color
      : 'var(--color-surface-raised, #FFFFFF)'};
  background: ${(props) => (props.bg ? props.bg : '')};

  .ant-switch-inner {
    background: var(--color-border, #dbeae3) !important;
  }

  .ant-switch-handle::before {
    background: ${(props) =>
      props.checked
        ? 'var(--color-primary, #41aaaf)'
        : 'var(--color-surface-raised, #FFFFFF)'}!important;
  }

  .switch-checked {
    .ant-switch-handle::before {
      background: var(--color-primary, #41aaaf) !important;
    }
  }

  .ant-card-body {
    padding: ${(props) => (props.$padding ? props.$padding : '24px')}!important;
  }

  ${(props) =>
    props.fullsize &&
    `
      .ant-card-body {
        width:100%
      }
    `}
  ${(props) =>
    props.$nopadding &&
    `
      .ant-card-body {
        padding:0 !important;
      }
    `}

    ${(props) =>
    props.centercontent &&
    `
      .ant-card-body {
        display: flex;
        justify-content: center;
      }
    `}
    
    ${(props) =>
    props.spreadcontent &&
    `
        .ant-card-body {
          display: flex;
          justify-content: space-between;
        }
      `}
    
    ${(props) =>
    props.hideheader &&
    `
        .ant-card-head {
          border-bottom: none;
          min-height: 20px !important;
          padding: 0 !important;
        }
        .ant-card-extra {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 10;
        }
      `}

          ${(props) =>
    props.$removeHeader &&
    `
        .ant-card-head {
          border-bottom: none;
          min-height: 0px !important;
        }
      `}
`;

export const GrayCard = styled(Card).attrs({
  className: 'scope-gray-card',
})`
  position: relative;
  background-color: var(--color-surface-raised, #ffffff) !important;
  border: 1px solid var(--color-border, #dbeae3) !important;
  border-radius: 15px;
  padding: 0 12px;
  font-family: Inter, sans-serif;
  color: var(--color-text-base, #2e2e2e);

  .ant-card-body {
    font-family: Inter, sans-serif;
    color: var(--color-text-base, #2e2e2e) !important;
    padding: 12px 16px;
  }

  &::after {
    content: '';
    width: 12px;
    height: 12px;
    position: absolute;
    top: -1px;
    left: 93.5%;
    border-bottom: 1px solid var(--color-border, #dbeae3);
    border-right: 1px solid var(--color-border, #dbeae3);
    transform: translate(-50%, -50%) rotate(225deg);
    background-color: var(--color-surface-raised, #ffffff);
  }
`;
